import styled from 'styled-components';

export const Container = styled.div`
  .page-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 90vh;
    background-color: #f5f5f5;
    padding: 20px;
    text-align: center;
  }

  .container {
    max-width: 800px;
  }

  h1 {
    color: #495057;
  }

  p {
    font-size: 18px;
  }

  input[type='text'] {
    padding: 10px 14px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 6px;
    width: 300px;
    margin-right: 10px;
  }

  .btn {
    padding: 10px 20px;
    font-size: 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
  }
`;
